export default __webpack_public_path__ + "38f19ac8a27e477526696cb80296a0a5.svg";